import { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import withAuth from "../../components/withAuth";
import SiteMonitoringListFilters from "../../components/SiteMonitoring/SiteMonitoringListFilters.jsx";
import {
	setFilteredAndSortedSiteMonitorings,
	getAllTags,
	synchronizeSiteMonitorings,
} from "../../redux/siteMonitoring/siteMonitoringActions";
import { getAllUsers } from "../../redux/users/usersActions";
import SiteMonitoringListDetail from "../../components/SiteMonitoring/SiteMonitoringListDetail";
import List from "@mui/material/List";
import Fab from "@mui/material/Fab";
import Icon from "@mui/material/Icon/Icon";
import FooterFixedOnScreen from '../Layout/FooterFixedOnScreen';

class SiteMonitorings extends Component {
	constructor(props) {
		super(props);

		props.getAllUsers(props.activeUser);
		props.getAllTags(props.activeUser);
		props.setFilteredAndSortedSiteMonitorings(
			{
				...props.siteMonitoringListFilters,
			},
			null,
			this.props.activeUser.id
		);
	}

	componentWillUnmount() {
		// this.props.cleanOldSiteMonitorings({ ...this.props.filteredAndSortedSiteMonitorings });
	}

	onSyncClick() {
		this.props.synchronizeSiteMonitorings(
			this.props.activeUser,
			this.props.history,
			() => {
				this.props.setFilteredAndSortedSiteMonitorings(
					{ ...this.props.siteMonitoringListFilters },
					null,
					this.props.activeUser.id
				);
			},
			this.props.siteMonitoringListFilters
		);
	}

	render() {
		let details = [];

		this.props.filteredAndSortedSiteMonitorings.forEach((sm) => {
			details.push(
				<SiteMonitoringListDetail
					globalContainer={this.props.globalStore.container}
					className="site-monitoring-list-detail"
					key={sm.id}
					siteMonitoring={sm}
				/>
			);
		});

		return (
			<div className="container-with-footer">
				<SiteMonitoringListFilters />
				<List className="row">{details.map((d) => d)}</List>
				<FooterFixedOnScreen>
					<div className="row">
						<div className="col-lg-1 col-md-2 col-sm-4 col-6">
							<Fab
								onClick={this.onSyncClick.bind(this)}
								className={"div-center"}
							>
								<Icon>sync</Icon>
							</Fab>
							<span className="floating-btn-text span-center">
								Synchroniser
							</span>
						</div>
					</div>
				</FooterFixedOnScreen>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		activeUser: state.activeUser,
		filteredAndSortedSiteMonitorings:
			state.siteMonitorings.filteredAndSortedSiteMonitorings,
		siteMonitoringListFilters: state.siteMonitorings.siteMonitoringsFilters,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getAllUsers: (user) => dispatch(getAllUsers(user)),
		getAllTags: (user) => dispatch(getAllTags(user)),
		synchronizeSiteMonitorings: (user, history, onSynchro, filters) =>
			dispatch(synchronizeSiteMonitorings(user, history, onSynchro, filters)),
		setFilteredAndSortedSiteMonitorings: (
			filteredAndSortedSiteMonitorings,
			siteMonitorings,
			userId
		) =>
			dispatch(
				setFilteredAndSortedSiteMonitorings(
					filteredAndSortedSiteMonitorings,
					siteMonitorings,
					userId
				)
			),
		// cleanOldSiteMonitorings: (filteredAndSortedSiteMonitorings) => dispatch(cleanOldSiteMonitorings(filteredAndSortedSiteMonitorings)),
	};
};

export default compose(
	withAuth,
	withRouter,
	connect(mapStateToProps, mapDispatchToProps)
)(SiteMonitorings);
